import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=90783024&scoped=true&"
var script = {}
import style0 from "./Navbar.vue?vue&type=style&index=0&id=90783024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90783024",
  null
  
)

export default component.exports